import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as firebase from 'firebase'
import { AngularFireFunctions } from '@angular/fire/functions';


@Injectable({
  providedIn: 'root'
})
export class ServiEliminaUsuarioService {

  constructor(private functions: AngularFireFunctions) { }


  eliminarCuenta(idCuenta,idUsers,  callback){

  
    // Use the function name from Firebase
    const callable = this.functions.httpsCallable('deleteUser');
  
    // Create an Observable and pass any data you want to the function
    const obs = callable({idCuenta:idCuenta});
  
    obs.subscribe( res => {

      if(res.result == 'OK'){
        firebase.firestore().collection("users").doc(idUsers).delete().then(()=>{
          callback("eliminado")
        }).catch((err)=>{
          callback(err)
        })
      }else{
        callback("error")
      }
    });
  
  }


  // 
  





 





}//fin de clase


